import { RegexControlConfig } from "utils/Regexvalidationcontrol/regexControl";

export const REGEX_CONTROL: RegexControlConfig = {
  enabledGlobally: true, // yahin se poori app ka regex ON/OFF

  // example: off any category regex
  disabledCategories: [
    // "Insurance",
  ],

  // example: off any biller regex
  disabledBillers: [
    // "OU12IC000NATGF",
  ],
};
